module.exports = __webpack_public_path__ + "media/images/help/line/eyecatch-example-6cf707666d20191b20791509dbb9d4fb.png";